export const MESSAGES=[
 
    {
        source:'Administration ' ,
        sujet:'Publication de calandrier des examens',
        date: '12/02/2024' ,

    } 
    ,
    {
        source:'Administration ISIMM' ,
        sujet:'Publication de calandrier des examens',
        date: '12/02/2024' ,

    } 
    ,
    {
        source:'Administration ISIMM' ,
        sujet:'Publication de calandrier des examens',
        date: '12/02/2024' ,

    }   ,
    {
        source:'Administration ISIMM' ,
        sujet:'Publication de calandrier des examens',
        date: '12/02/2024' ,

    }   ,
    {
        source:'Administration ISIMM' ,
        sujet:'Publication de calandrier des examens',
        date: '12/02/2024' ,

    }   ,
    {
        source:'Administration ISIMM' ,
        sujet:'Publication de calandrier des examens',
        date: '12/02/2024' ,

    }   ,
    {
        source:'Administration ISIMM' ,
        sujet:'Publication de calandrier des examens',
        date: '12/02/2024' ,

    }   ,
    {
        source:'Administration ISIMM' ,
        sujet:'Publication de calandrier des examens',
        date: '12/02/2024' ,

    }   ,
    {
        source:'Administration ISIMM' ,
        sujet:'Publication de calandrier des examens',
        date: '12/02/2024' ,

    }   ,
    {
        source:'Administration ISIMM' ,
        sujet:'Publication de calandrier des examens',
        date: '12/02/2024' ,

    }   ,
    {
        source:'Administration ISIMM' ,
        sujet:'Publication de calandrier des examens',
        date: '12/02/2024' ,

    }   ,
    {
        source:'Administration ISIMM' ,
        sujet:'Publication de calandrier des examens',
        date: '12/02/2024' ,

    }   ,
    {
        source:'Administration ISIMM' ,
        sujet:'Publication de calandrier des examens',
        date: '12/02/2024' ,

    }   ,
    {
        source:'Administration ISIMM' ,
        sujet:'Publication de calandrier des examens',
        date: '12/02/2024' ,

    } 
    

]